@let menu = menuStore.mainMenu();
@let firstLink = menu?.[0]?.children?.[0]?.url || '';

<!-- DESKTOP -->
@if (mini) {
  <ng-container *ngTemplateOutlet="nav"></ng-container>
  <span fxFlex></span>
  <footer>
    <ng-template [ngTemplateOutlet]="user"></ng-template>
    <a
      mat-icon-button
      [@trigger]="expanded ? '1' : '0'"
      (click)="sidenavToggle.emit()"
      [matTooltip]="
        (expanded ? 'FTR_MENU_COLLAPSE' : 'FTR_MENU_EXPAND') | translate
      "
      matTooltipPosition="after">
      <mat-icon svgIcon="right-arrow"></mat-icon>
    </a>
  </footer>
} @else {
  <ng-container *ngTemplateOutlet="nav"></ng-container>
  <span fxFlex></span>
  <ng-template [ngTemplateOutlet]="user"></ng-template>
}

<!-- Mobile sidenav -->

<!-- nav reference -->
<ng-template #nav>
  <mat-toolbar class="mat-toolbar--small">
    <div fxLayout="column" fxLayoutAlign="space-around center">
      <a
        [routerLink]="'/' + firstLink"
        (click)="sidenav.opened && sidenav.close()">
        <mat-icon class="sidenav-mini__logo" svgIcon="main-logo"></mat-icon>
      </a>
    </div>
    @if (!mini || expanded) {
      <h1 class="sidenav-mini__mobile-title">
        {{ (mobileTitle() | translate)?.toLowerCase() }}
      </h1>
    }
  </mat-toolbar>
  <mat-nav-list class="nav">
    @for (menuEntry of menu; track menuEntry.title; let i = $index) {
      @if (!mini || expanded) {
        <p class="nav__header mat-subtitle-2">
          {{ menuEntry.title | translate }}
        </p>
      }
      @for (subMenu of menuEntry.children; track subMenu.title) {
        <a
          mat-list-item
          [ngClass]="!mini || expanded ? 'nav__link-opened' : 'nav__link'"
          routerLink="/{{ subMenu.url }}"
          routerLinkActive="active-list-item"
          [routerLinkActiveOptions]="!subMenu.url ? { exact: true } : $any({})"
          [matTooltipDisabled]="!mini || expanded"
          matTooltip="{{ menuEntry.title | translate }}: {{
            subMenu.title | translate
          }}"
          matTooltipPosition="right"
          matTooltipShowDelay="100"
          style="width: inherit !important">
          @if (subMenu.icon.ent === 'google') {
            <mat-icon
              matListItemIcon
              [class.nav__icon-flip]="subMenu.icon.flip">
              {{ subMenu.icon.name }}
            </mat-icon>
          } @else {
            <mat-icon
              matListItemIcon
              [svgIcon]="subMenu.icon.name"
              [class.nav__icon-flip]="subMenu.icon.flip"></mat-icon>
          }

          <p
            class="nav__link__title"
            matListItemTitle
            [class.hidden]="mini && !expanded">
            {{ subMenu.title | translate }}
          </p>
        </a>
      }
    }
  </mat-nav-list>
</ng-template>

<ng-template #user>
  @if (!media.isActive('gt-xs')) {
    <qt-avatar-menu [sidenav]="sidenav"></qt-avatar-menu>
  }
</ng-template>
